import DeletedMessage from './DeletedMessage'
export default DeletedMessage
